module.exports = __webpack_public_path__ + "static/media/IMG_8013.89fd5017.jpg";